module.exports = __webpack_public_path__ + "static/media/italyrobot&ml.8c6b59f3.jpg";